export const invoiceStatus = (status: string) => {
    switch (status) {
        case 'PENDING':
            return 'Afventer';
        case 'ACTIVE':
            return 'Udestående';
        case 'PARTIALLY_PAID':
            return 'Delvist betalt';
        case 'DONE':
        case 'FINISH':
            return 'Betalt';
        case 'IN_PROGRESS':
            return 'Behandler';
        case 'CANCEL':
        case 'CANCELLED':
            return 'Annulleret';
        case 'EXCEPTION':
            return 'Fejl';
        case 'DEPRECIATED':
            return 'Afskrevet';
        case 'DEBT_COLLECTION':
            return 'Inkasso';
        default:
            return 'Ukendt';
    }
}

export const creditnoteStatus = (status: string) => {
    switch (status) {
        case 'PENDING':
            return 'Afventer';
        case 'ACTIVE':
            return 'Ugyldig';
        case 'DONE':
        case 'FINISH':
            return 'Indsat på saldo';
        case 'IN_PROGRESS':
            return 'Behandler';
        case 'CANCEL':
        case 'CANCELLED':
            return 'Annulleret';
        case 'EXCEPTION':
            return 'Fejl';
        default:
            return 'Ukendt';
    }
}
